import EventTableFilter from "./event-table-filter";

const EventFilters = {
    Table: EventTableFilter
}

export default EventFilters;